import { useNavigate } from "react-router-dom";
import { Clock, Monitor, Plus, ArrowRight } from "lucide-react";
import { formatMXN } from "../lib/format";
import { CATEGORY_LABEL } from "../lib/brand";
import { useCart } from "../context/CartContext";

export const ProductCard = ({ product, featured = false }) => {
  const navigate = useNavigate();
  const { addItem } = useCart();

  return (
    <div
      data-testid={`product-card-${product.id}`}
      className={`card-hover group flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white ${
        featured ? "sm:col-span-2 sm:flex-row" : ""
      }`}
    >
      <div
        className={`relative cursor-pointer overflow-hidden ${featured ? "sm:w-1/2" : ""}`}
        onClick={() => navigate(`/producto/${product.id}`)}
      >
        <img
          src={product.image}
          alt={product.title}
          className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${
            featured ? "h-56 sm:h-full" : "h-48"
          }`}
        />
        <div className="absolute left-3 top-3 flex gap-2">
          <span className="rounded-full brand-navy px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-white">
            {CATEGORY_LABEL[product.category] || product.category}
          </span>
          {product.old_price && (
            <span className="rounded-full bg-emerald-500 px-2.5 py-1 text-[11px] font-bold text-white">
              Oferta
            </span>
          )}
        </div>
      </div>

      <div className={`flex flex-1 flex-col p-5 ${featured ? "sm:w-1/2 sm:justify-center sm:p-8" : ""}`}>
        {product.ec_code && (
          <span className="font-mono-data mb-2 text-[11px] font-semibold tracking-wider text-brand-forest">
            {product.ec_code}
          </span>
        )}
        <h3
          className={`cursor-pointer font-display font-bold leading-snug text-brand-navy transition-colors group-hover:text-brand-forest ${
            featured ? "text-2xl" : "text-lg"
          }`}
          onClick={() => navigate(`/producto/${product.id}`)}
        >
          {product.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm text-slate-500">{product.description}</p>

        <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs font-medium text-slate-500">
          {product.duration && (
            <span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5" /> {product.duration}</span>
          )}
          {product.modality && (
            <span className="flex items-center gap-1"><Monitor className="h-3.5 w-3.5" /> {product.modality}</span>
          )}
        </div>

        <div className="mt-4 flex items-end justify-between border-t border-slate-100 pt-4">
          <div>
            {product.old_price && (
              <span className="mr-2 text-sm text-slate-400 line-through">{formatMXN(product.old_price)}</span>
            )}
            <span className="font-display text-xl font-extrabold text-brand-navy">
              {formatMXN(product.price)}
            </span>
            <p className="text-[11px] text-slate-400">IVA incluido</p>
          </div>
        </div>

        <div className="mt-4 flex gap-2">
          <button
            data-testid={`product-view-details-${product.id}`}
            onClick={() => navigate(`/producto/${product.id}`)}
            className="flex flex-1 items-center justify-center gap-1 rounded-xl border border-slate-200 py-2.5 text-sm font-semibold text-brand-navy transition-colors hover:border-brand-navy"
          >
            Ver detalles <ArrowRight className="h-4 w-4" />
          </button>
          <button
            data-testid={`product-add-cart-${product.id}`}
            onClick={() => addItem(product)}
            className="flex items-center justify-center gap-1 rounded-xl brand-forest px-4 py-2.5 text-sm font-bold text-white transition-transform hover:scale-[1.03]"
          >
            <Plus className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
